import { createContext, useContext } from 'react';

interface ILayoutContextValues {
    totalNavbarHeight: number;
    bodyElement: HTMLElement;
    shadowRoot?: ShadowRoot;
}

export const LayoutContext = createContext<ILayoutContextValues | null>(null);

export function useLayout() {
    const context = useContext(LayoutContext);
    if (context == null) throw new Error('useLayout must be used within a <LayoutContext.Provider>');

    return context;
}
